import { render, staticRenderFns } from "./CampaignIcon.vue?vue&type=template&id=18fd46a4"
import script from "./CampaignIcon.vue?vue&type=script&lang=js"
export * from "./CampaignIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports